import React, {Component} from 'react';
import {request} from "../../helper/APIUtils";
import {hasUserRight, showAxiosError} from "../../helper/helper";
import Table from "../../components/Table/Table";
import {Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import UserForm from "./component/UserForm";
import Alert from "react-s-alert";
import NavBarKS from "../../components/NavBarKS";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import SweetAlert from 'react-bootstrap-sweetalert';
import NotifyKS from "../../components/NotifyKS";
import {UserRightsEnum} from "../../helper/enums";
import StickButton from "../../components/StickButton";
import {VirtualHost} from "../../constants";

class UserList extends Component {

	constructor(props) {
		super(props);

		this.state = {
			selectedUser: null,
			branches: null,
			aliasList: null,
			users: [],
			loading: false,
			searching: false,
			searchQuery: undefined,
			total: 0,
			page: 0,
			size: 10,
			manual: false,
			addUserModal: false,
			alert: null,
			notify: null
		};

		this.listUsers = this.listUsers.bind(this);
		this.cancelUserCreation = this.cancelUserCreation.bind(this);
		this.saveUser = this.saveUser.bind(this);
		this.getAliasList = this.getAliasList.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleCustomizeSidebar = this.handleCustomizeSidebar.bind(this);

	}

	componentDidMount() {
		this.getAliasList();
	}

	listUsers(accessor, direction, page, size) {
		let self = this;
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc';
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/user/fetchUsers?page=' + page + '&size=' + size + sortStr + searchQuery,
			method: "get",
		};
		self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
		self.props.reload(true);
		request(params)
				.then(function (response) {
					let users = response.data.content;
					self.setState({
						page: page,
						size: size,
						total: response.data.totalElements,
						users,
						loading: false,
						searching: false
					});
					self.props.reload(false);
				}).catch(function (error) {
			self.setState({loading: false, searching: false});
			self.props.reload(false);
			showAxiosError(error);
		});
	}

	saveUser(content) {
		let self = this;
		let data = content;
		let params = {
			url: `/user/createUser`,
			data: data,
			method: 'post'
		};
		request(params).then(() => {
			Alert.success('Kullanıcı başarıyla kaydedildi.', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000,
				html:false
			});
			self.setState({
				addUserModal: false,
				branches: null,
				manual: true
			})
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

	getAliasList() {
		let self = this;
		let params = {
			url: `/user/getAliasList`,
			method: 'post'
		};
		request(params).then(function (response) {
			self.setState({aliasList: response.data})
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

	cancelUserCreation() {
		this.setState({
			addUserModal: false,
			selectedUser: null
		})
	}

	handleEdit(item) {
		let self = this;
		let data = item.recordId;
		let params = {
			url: `/user/fetchUserByRecordId`,
			data: data,
			method: 'post'
		};
		request(params).then(function (response) {
			self.setState({
				mode: 'edit',
				selectedUser: response.data.user,
				userBranchMap: response.data.branchMap,
				addUserModal: true
			})
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

	handleSearch(searchQuery) {
		this.setState({
			searchQuery,
			searching: true
		}, () => this.listUsers(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	handleDelete(item) {
		let self = this;
		let params = {
			url: `/user/deleteUser`,
			data: item,
			method: 'post'
		};

		const deleteUser = () =>
			request(params).then(function (response) {
				self.setState({
					notify: {
						type: 'success',
						message: 'Kullanıcı başarıyla silindi',
					},
					alert: null
				});
				self.listUsers(null, null, null, null);
			}).catch(function (error) {
				self.setState({
					alert: null
				});
				showAxiosError(error);
			});

		this.setState({
			alert: (
					<SweetAlert showCancel warning
								disabled={this.state.loading}
								confirmBtnText="Evet"
								cancelBtnText="Hayır"
								confirmBtnBsStyle="danger"
								cancelBtnBsStyle="default"
								title="Emin misiniz?"
								onConfirm={() => {
									deleteUser(item)
								}}
								onCancel={() => this.setState({alert: null, notify: null})}>
						{item.username} kullanıcısı silinecek..! Onaylıyor musunuz ?
					</SweetAlert>
			)
		})
	}

	handleCustomizeSidebar(item) {
		this.props.history.push({pathname: `/customizeSidebar/${item.recordId}`, source: 'userList'});
	}

	handleCustomizeRights(item) {
		this.props.history.push({pathname: `/userRights/${item.recordId}`, source: 'userList'});
	}

	handleSendMail(item) {

		const confirm = () => {
			this.setState({style: 'fas fa-spinner fa-spin'})
			let self = this;
			let params = {
				url: `/user/sendNewMail`,
				method: 'post',
				data: item.recordId
			};
			request(params).then(function (response) {
				Alert.warning('İsteğiniz sıraya alınmıştır.', {
					position: 'top-right',
					effect: 'stackslide',
					offset: 100,
					timeout: 5000,
					html:false
				});
				self.setState({style: 'fas fa-at', alert: null});
			}).catch(function (error) {
				self.setState({style: 'fas fa-at', alert: null})
				showAxiosError(error);
			});
		};

		this.setState({
			alert: (
					<SweetAlert showCancel warning
								confirmBtnText="Onayla"
								cancelBtnText="İptal"
								confirmBtnBsStyle="danger"
								cancelBtnBsStyle="default"
								title="Emin misiniz?"
								onConfirm={() => confirm()}
								onCancel={() => this.setState({alert: null})}
					>
						{'Giriş bilgileri ' + item.email + ' adresine yeniden gönderilecek.'}
					</SweetAlert>
			)
		});
	}

	render() {
		const {users} = this.state;
		const source = VirtualHost.conf.resourcePrefix;

		const columns = [
			{
				Header: "Ad",
				title: "Ad",
				accessor: "firstName",
			},
			{
				Header: "Soyad",
				title: "Soyad",
				accessor: "lastName",
			},
			{
				Header: "Kullanıcı Adı",
				title: "Kullanıcı Adı",
				accessor: "username",
			},
			{
				Header: "e-Posta",
				title: "e-Posta",
				accessor: "email",
			},
			{
				Header: "Rol",
				title: "Rol",
				accessor: "",
				Cell: item => (
						<label>{(["smart", "kolaysoft"].includes(VirtualHost.conf.resourcePrefix) && this.props.isEntegrator)
							? ((item.roleId && item.roleId.recordId === 4) ? "BAYİ SORUMLUSU"
							: (item.roleId && item.roleId.recordId === 5 ? "BELGE DURUMU" : item.roleId && item.roleId.roleName))
							: (item.roleId && item.roleId.roleName)}</label>
				)
			},
			{
				Header: "İşlemler",
				title: "İşlemler",
				accessor: "",
				sortable: false,
				Cell: item => (
						<div className="btn-group">
							<div className="dropdown">
								<button className="MenuBtn2 listt btn btn-default" type="button"
										data-toggle="dropdown">Seçİnİz
								</button>
								<div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + item.recordId}>
									{(hasUserRight(UserRightsEnum.settings.user.update, this.props.currentUser) && (this.props.impersonateUserRoleId !== 3 && this.props.impersonateUserRoleId !== 4))&&
									<a className="dropdown-item" onClick={() => this.handleEdit(item)}>
										<i className="fa fa-edit"/> Kullanıcı Bilgilerini Düzenle

									</a>
									}
									{hasUserRight(UserRightsEnum.settings.user.delete, this.props.currentUser) &&
									<a className="dropdown-item" onClick={() => this.handleDelete(item)}>
										<i className="fas fa-trash"/> Kullanıcıyı Sil
									</a>
									}

									{hasUserRight(UserRightsEnum.settings.user.sendMail, this.props.currentUser) && !item.username.endsWith("_eczpos") &&
									<a className="dropdown-item" onClick={() => this.handleSendMail(item)}>
										<i className="fas fa-at"/> Kullanıcıya Şifre Maili Gönder
									</a>
									}
									{(!this.props.currentUser.accountant || (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
									hasUserRight(UserRightsEnum.settings.user.update, this.props.currentUser) &&
									<a className="dropdown-item" onClick={() => this.handleCustomizeSidebar(item)}>
										<i className="fas fa-bars"/> Kullanıcı Yan Menüsünü Düzenle
									</a>}

									{(!this.props.currentUser.accountant || (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
									hasUserRight(UserRightsEnum.settings.user.update, this.props.currentUser) &&
									<a className="dropdown-item" onClick={() => this.handleCustomizeRights(item)}>
										<i className="fas fa-user-lock"/> Kullanıcı Yetkilerini Düzenle
									</a>}

								</div>
							</div>
						</div>
				)
			}
		];

		const fields = [
			{
				label: "Ad",
				accessor: "firstName",
				type: "text",
				operator: "=",
			},
			{
				label: "Soyad",
				accessor: "lastName",
				type: "text",
				operator: "=",
			},
			{
				label: "Kullanıcı Adı",
				accessor: "username",
				type: "text",
				operator: "=",
			}
		];
		return (
				<div className="row baseBackground">

					{this.state.alert && this.state.alert}

					<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
						<StickButton position="leftSide"
									 onClick={() => this.setState({addUserModal: true, mode: 'create'})}
									 disabled={!hasUserRight(UserRightsEnum.settings.user.create, this.props.currentUser) || (this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4)}
									 label="Yeni Oluştur" title="Yeni Oluştur" className="stickButton user-plus"/>
					</NavBarKS>

					<div className="col-md-12 satirBasi">

						{this.state.notify &&
						<Row>
							<NotifyKS
									type={this.state.notify.type}
									message={this.state.notify.message}
									html={this.state.notify.html}
									timeout={this.state.notify.timeout}
									autohide={this.state.notify.autohide}
							/>
						</Row>}

						<div className="card-header ">
							<h4 className="card-title">Kullanıcı Listesi</h4>
						</div>
						<div className="card-body">
							<div className=" ">
								<div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
									<DetailedSearch fields={fields}
													loading={this.state.searching}
													onSearch={this.handleSearch}/>
								</div>
							</div>
						</div>
						<div className="card-body">
							<Table
									loading={this.state.loading}
									loadingText="Kayıtlar getiriliyor..."
									content={users}
									total={this.state.total}
									page={this.state.page}
									manual={this.state.manual}
									size={this.state.size}
									options={["5", "10", "20"]}
									columns={columns}
									fetchData={this.listUsers}
							/>
						</div>
					</div>

					<Modal isOpen={this.state.addUserModal} size="lg" className="ust">
						<ModalHeader toggle={this.cancelUserCreation}>Kullanıcı Düzenle</ModalHeader>
						<ModalBody>
							<UserForm saveUser={this.saveUser} cancelProcess={this.cancelUserCreation}
									  selectedUser={this.state.selectedUser} mode={this.state.mode}
									  branchMap={this.state.userBranchMap} aliasList={this.state.aliasList}
									  module={this.props.name}
									  currentUser={this.props.currentUser}/>
						</ModalBody>
					</Modal>

				</div>
		)
	}
}

export default UserList;